export default __webpack_public_path__ + "static/media/orange_moon.77b851d6.jpg";